import React, { ChangeEvent, CSSProperties, PureComponent, ReactNode } from 'react'
import { Tooltip } from '../Tooltip'
import StyledDiv from './styles'
import { images } from '../../images'
import countries from '../../countries.json'
import { connect, DispatchProp } from "react-redux";
import { ICountry } from '../../models/country'
import { setToggleCountryPickerModalAction } from '../../store/actions'

interface IProps extends DispatchProp<any> {
  label: string
  name: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  error?: boolean
  styles?: CSSProperties
  containerStyles?: CSSProperties
  isPassword?: boolean
  isReadonly?: boolean
  tooltip?: string
  onFocus?: (focused: boolean) => void
  phone?: boolean
  locale?: string
  country?: ICountry
}

interface IState {
  isFocused: boolean
  showPassword: boolean
}

class ValidatedInput extends PureComponent<IProps, IState> {
  private get getFlag() {
    return countries.find(country => {
      return country?.code === this.props.country?.code
    })
  }

  constructor(props: IProps) {
    super(props)
    const { locale } = this.props
    this.state = {
      isFocused: false,
      showPassword: false
    }
  }

  handleFocus = () => {
    this.setState({ isFocused: true })
    const { onFocus } = this.props
    if (onFocus && typeof onFocus === 'function') onFocus(true)
  }

  handleBlur = () => {
    this.setState({ isFocused: false })
    const { onFocus } = this.props
    if (onFocus && typeof onFocus === 'function') onFocus(false)
  }
  
  handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { phone, country, onChange } = this.props
    if (phone && event.target.value.length > Number(country?.maxLength)) {
      event.preventDefault()
    } else {
      if (onChange && typeof onChange === 'function') onChange(event.currentTarget.value)
    }
  }

  public render(): ReactNode {
    const { name, value, error, tooltip, containerStyles, label, styles, isPassword, isReadonly, placeholder, phone, country, dispatch } = this.props
    const { isFocused, showPassword } = this.state

    const isInvalid = !isFocused && !!value && !!error
    const classNames = `${ (!isFocused && !value) || 'filled' } ${ isInvalid && 'invalid' }`
    const tooltipContent = !tooltip ? null : <Tooltip>{ tooltip }</Tooltip>
    return (
      <StyledDiv className={ classNames } style={containerStyles}>
        {
          phone && 
          <div className='phone-code-container' onClick={() => dispatch(setToggleCountryPickerModalAction())}>
            <div className='flag-container'>
              { this.getFlag?.emoji }
            </div>
            {
              country !== null &&
              <span>{ country?.dial_code }</span>
            }
          </div>
        }
        <label className={ phone ? 'phone-input' : '' } htmlFor={ name }>{ label }</label>
        <input
          id={ name }
          value={ value }
          style={ styles }
          type={ isPassword && !showPassword ? 'password' : phone ? 'number' : 'text' }
          onFocus={ this.handleFocus }
          onBlur={ this.handleBlur }
          onChange={ this.handleChange }
          readOnly={ isReadonly }
          placeholder={ placeholder }
          className={ phone ? 'phone-input' : '' }
        />
        { tooltipContent }
        { 
          isPassword && 
          <div className='password-visibility' onClick={() => this.setState({ showPassword: !showPassword })}>
            <img src={showPassword ? images.password_no_visibility : images.password_visibility} alt='passwod-visibility' />
          </div>
        }
      </StyledDiv>
    )
  } 
}

export default connect()(ValidatedInput)
